import React from "react";
import { connect } from "react-redux";
import Request, { API_URL, LAPI_URL } from "../../request";
import moment from "moment";
import _ from 'lodash';
import { Drawer, Icon, notification, Card, Row, Col, Checkbox, Popover, Input, Button, Upload } from "antd";
import { RightsWrapper } from "../_utils/utils";
import generateInvoice from "../../containers/Desk/claim/claimProcessing/generateInvoice";
let companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
let dateFormat = companyDetails && companyDetails.dateFormat ? companyDetails.dateFormat : 'DD.MM.YYYY';
let companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

class GroupInvoiceChangeStatus extends React.Component {
    state = {
        visible: true,
        generatedInvoice: {},
        hasConversionRate: false,
        invoiceStatus: null,
        showInvoiceNumber: false,
        showInvoiceDate: false,
        invoiceNumber: null,
        invoiceGeneratedDate: null,
        cardLoading: false,
        taxLoading: false,
        additionalDeduction: false,
        hasBankCharges: false,
        invoiceStatuses: [
            'Generated', 'Submitted to Uni', 'Approved by Uni', 'Paid by Uni', 'Cleared'
        ]
    }

    loadInvoiceDetail = async () => {
        const { invoiceId } = this.props;
        const res = await Request.getInvoiceDetail(invoiceId);
        if (!res.error) {
            this.setState({ generatedInvoice: res.doc });
            // if (res.doc.invoiceThroughCp) {
            //     this.setState({ invoiceThroughCp: res.doc.invoiceThroughCp })
            // }
            if (res.doc.hasConversionRate) {
                this.setState({ hasConversionRate: res.doc.hasConversionRate });
            }
            if (res.doc.additionalDeduction) {
                this.setState({ additionalDeduction: res.doc.additionalDeduction });
            }
            if (res.doc.hasBankCharges) {
                this.setState({ hasBankCharges: res.doc.hasBankCharges });
            }
            if (res.doc.cpTaxTypeId || res.doc.taxTypeId) {
                this.updateCpTax(res.doc.cpTaxTypeId ? res.doc.cpTaxTypeId : res.doc.taxTypeId);
            }
            if (res.doc.additionalTaxTypeId) {
                this.setState({ additionalTaxTypeId: res.doc.additionalTaxTypeId });
            }
            if (res.doc.bankCharges) {
                this.setState({ bankCharges: res.doc.bankCharges });
            }

        }
    }

    updateAdditionalCpTax = async (e) => {
        let { hasConversionRate, generatedInvoice, additionalDeduction } = this.state;
        if (additionalDeduction && hasConversionRate) {
            if (e === "") {
                generatedInvoice.additionalTaxTypeId = ""
                this.setState({ additionalTaxTypeId: e, additionalTaxPercentange: 0, generatedInvoice })
            }
            let response = await Request.financeTaxDetailsByID({ id: e });
            let { taxTypeArray } = response.doc
            let totalTaxPercentage = 0
            _.each(taxTypeArray, (tax) => {
                totalTaxPercentage += parseFloat(tax.taxValue)
            })
            generatedInvoice.additionalTaxTypeId = e;
            generatedInvoice.additionalTaxName = response.doc.taxTitle;
            this.setState({ additionalTaxTypeId: e, additionalTaxPercentange: totalTaxPercentage, generatedInvoice, additionalTaxName: response.doc.taxTitle })
        } else {
            generatedInvoice.additionalTaxTypeId = e;
            this.setState({ generatedInvoice })
        }
    }

    loadCompanyBankDetails = async () => {
        let response = await Request.getCompanyBankDetails();
        if (!response.error) {
            this.setState({ companyDetails: response.results });
        } else {
            notification.error({
                message: 'Error generating invoice'
            })
        }
    }

    getAllTaxes = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        let data = await Request.getTaxDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allTaxes: data.data });
    }

    getAllInvoiceToDetails = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        params.sortField = 'invoiceToName'
        params.sortOrder = 'ascend'
        let data = await Request.getInvoiceToDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allInvoiceToDetails: data.data });
    }

    loadCountry() {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
            businessId: activeUser && activeUser.businessId
        };
        Request.getCountriesWithoutAuth(params)
            .then((resp) => {
                if (resp) {
                    let temp = [];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id,
                        });
                    });
                    this.setState({ countryArr: temp });
                }
            })
            .catch((err) => {
            });
    }

    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ 'universities': resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadChannelPartner = async () => {
        Request.loadChannelPartners({
            results: 10000,
            count: 1000
        })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.channelPartnerName })
                    return temp
                }, [])

                this.setState({ 'channelPartners': resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    updateCpTax = async (e) => {
        this.setState({ taxLoading: true });
        let { hasConversionRate, generatedInvoice } = this.state;
        if (hasConversionRate == true) {
            if (e === "") {
                generatedInvoice.taxTypeId = ""
                this.setState({ cpTaxTypeId: e, taxPercentange: 0, generatedInvoice, taxLoading: false })
            }
            let response = await Request.financeTaxDetailsByID({ id: e })
            let { taxTypeArray } = response.doc
            let totalTaxPercentage = 0
            _.each(taxTypeArray, (tax) => {
                totalTaxPercentage += parseFloat(tax.taxValue)
            })
            generatedInvoice.taxTypeId = e;
            this.setState({ cpTaxTypeId: e, taxPercentange: totalTaxPercentage, generatedInvoice, taxLoading: false })
        } else {
            generatedInvoice.taxTypeId = e;
            this.setState({ generatedInvoice, taxLoading: false })
        }
    }

    handleChange = (v) => {
        if (v.fileList) {

            let generatedInvoice = this.state.generatedInvoice;
            generatedInvoice.paymentReceipt = v.fileList;
            this.setState({ generatedInvoice: generatedInvoice });
        }
    };

    onRemove = (v) => {
        console.log(v);
    };

    constructor(props) {
        super(props);
        this.tableScrollRef = React.createRef();
    }


    async componentDidMount() {
        this.setState({ cardLoading: true });

        await Promise.all([
            this.loadInvoiceDetail(),
            this.loadCompanyBankDetails(),
            this.getAllTaxes(),
            this.getAllInvoiceToDetails(),
            this.loadCountry(),
            this.loadUniversity(),
            this.loadChannelPartner()
        ]);
        this.setState({ cardLoading: false });
    }

    updateInvoiceStatus = async () => {
        const { invoiceId } = this.props;
        const { generatedInvoice, hasConversionRate, hasBankCharges, additionalDeduction } = this.state;
        if (!generatedInvoice.paymentReceipt && (generatedInvoice.invoiceStatus == "Cleared" || generatedInvoice.invoiceStatus == "Paid By Uni")) {
            notification.error({
                message: 'Please Upload Payment Receipt'
            });
            return
        }


        let dataToSend = {
            invoiceId: invoiceId,
            hasBankCharges: hasBankCharges,
            additionalDeduction: additionalDeduction,
            hasConversionRate: hasConversionRate,
            invoices: generatedInvoice.invoices,
            invoiceStatus: generatedInvoice.invoiceStatus,
            invoiceReceivingDate: generatedInvoice.invoiceReceivingDate,
            taxTypeId: generatedInvoice.cpTaxTypeId ? generatedInvoice.cpTaxTypeId : generatedInvoice.taxTypeId,
            invoiceThroughCp: generatedInvoice.invoiceThroughCp ? generatedInvoice.invoiceThroughCp : false,
            taxPaidBy: generatedInvoice.taxPaidBy,
            paymentReceipt: generatedInvoice.paymentReceipt ? generatedInvoice.paymentReceipt : null
        }

        if (this.state.invoiceNumber) {
            dataToSend.invoiceNumber = this.state.invoiceNumber;
        }
        if (generatedInvoice.additionalTaxTypeId) {
            dataToSend.additionalTaxTypeId = generatedInvoice.additionalTaxTypeId;
        }

        if (generatedInvoice.bankCharges) {
            dataToSend.bankCharges = generatedInvoice.bankCharges;
        }


        if (this.state.invoiceGeneratedDate) {
            dataToSend.invoiceGeneratedDate = this.state.invoiceGeneratedDate;
        }

        // let x = await Request.updateNewInvoiceStatus({ invoiceId, invoiceStatus: generatedInvoice.invoiceStatus, invoiceReceivingDate: generatedInvoice.invoiceReceivingDate, paymentReceipt: generatedInvoice.paymentReceipt });
        this.setState({ loading: true });
        let x = await Request.updateNewInvoiceStatus(dataToSend);
        this.setState({ loading: false });
        if (!x.error) {
            notification.success({
                message: 'Invoice updated successfully'
            });
            this.onClose();
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }
    }

    selectInvoiceReceivingDate = (e) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoiceReceivingDate = e.target.value;
        this.setState({ generatedInvoice: generatedInvoice });
    }

    selectInvoiceStatus = (e) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoiceStatus = e.target.value;
        this.setState({ generatedInvoice: generatedInvoice, invoiceStatus: e.target.value });
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    updateValue = (key, index, input) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoices[index][key] = input.target.value;
        this.setState({ generatedInvoice: generatedInvoice });
    }


    render() {
        let { generatedInvoice, showInvoiceNumber, showInvoiceDate, allTaxes, enableBTN, invoiceStatuses } = this.state;
        let invoiceReceivingDate = generatedInvoice.invoiceGeneratedDate ? moment(generatedInvoice.invoiceGeneratedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        let taxTypeId = generatedInvoice.cpTaxTypeId ? generatedInvoice.cpTaxTypeId : generatedInvoice.taxTypeId;
        let content = <p style={{ color: '#1890FF' }}>Since you have received the funds in your local currency, please apply the appropriate exchange rate to reconcile the amount accordingly.<br />
            Kindly refer to the table above and update the required details in the editable sections.</p>
        let invoiceCurrency = generatedInvoice && generatedInvoice.invoices && generatedInvoice.invoices.length > 0 ? generatedInvoice.invoices[0].currency : null;
        return (
            <Drawer
                title={
                    <div>
                        {'Update Status:- '} {' '} {generatedInvoice.invoiceNumber}<b>/</b>{moment(generatedInvoice.invoiceGeneratedDate).format(dateFormat)}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}
            >
                <Card loading={this.state.cardLoading || this.state.taxLoading}>

                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>
                            <div className='ant-table-scroll scrolling-table' style={{ overflow: 'auto' }} ref={this.tableScrollRef}>
                                <table className='ant-table-fixed' >
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Student ID</th>
                                            <th className='ant-table-row-cell-break-word'>Student Name</th>
                                            <th className='ant-table-row-cell-break-word'>Date Of Birth</th>
                                            <th className='ant-table-row-cell-break-word'>Course</th>
                                            <th className='ant-table-row-cell-break-word'>Course Start Date</th>
                                            <th className='ant-table-row-cell-break-word'>Tuition Fee Paid ({invoiceCurrency})</th>
                                            <th className='ant-table-row-cell-break-word'>Commission Percentage</th>
                                            <th className='ant-table-row-cell-break-word'>Commission Amount ({invoiceCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Exchange Rate({companyCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Net Amount({companyCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Tax Amount({companyCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Round-Off({companyCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Gross Amount({companyCurrency})</th>
                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody'>
                                        {generatedInvoice.invoices && generatedInvoice.invoices.map((invoice, index) => {
                                            let selectedStudent = invoice.inquiry
                                            return (
                                                <tr key={index}>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk && selectedStudent.visaDesk.selectedCourse && selectedStudent.visaDesk.selectedCourse.instituteStudentId ? selectedStudent.visaDesk.selectedCourse.instituteStudentId : selectedStudent.instituteStudentId ? selectedStudent.instituteStudentId : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.studentName}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.dateOfBirth ? moment(selectedStudent.dateOfBirth).format(dateFormat) : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.courseName : ''}{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.campusName ? `(${selectedStudent.visaDesk.selectedCourse.campusName})` : '' : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? moment(selectedStudent.visaDesk.courseStartDate).format(dateFormat) : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{invoice.tutionFee ? invoice.tutionFee : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{invoice.commissionFromCourse ? invoice.commissionFromCourse : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{invoice.commissionTypeFrom == 'Percentage' ? (parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100).toFixed(2) : (invoice.commissionFromCourse ? parseFloat(invoice.commissionFromCourse).toFixed(2) : '')}</td>
                                                    <td className='ant-table-row-cell-break-word' hidden={!this.state.hasConversionRate}><Input onChange={(e) => { this.updateValue('conversionRate', index, e) }} value={invoice.conversionRate} /></td>

                                                    <td className="ant-table-row-cell-break-word" hidden={!this.state.hasConversionRate}>
                                                        {
                                                            (() => {
                                                                const commissionFromCourse = parseFloat(invoice.commissionFromCourse || 0);
                                                                const tutionFee = parseFloat(invoice.tutionFee || 0);
                                                                const conversionRate = parseFloat(invoice.conversionRate || 0);
                                                                const taxPercent = parseFloat(this.state.taxPercentange || 0);
                                                                const generatedInvoice = this.state.generatedInvoice;

                                                                let total = 0;

                                                                if (invoice.commissionTypeFrom === 'Percentage') {
                                                                    total = (commissionFromCourse * tutionFee / 100) * conversionRate;
                                                                } else if (commissionFromCourse && conversionRate) {
                                                                    total = commissionFromCourse * conversionRate;
                                                                }

                                                                // Deduct tax portion if taxPercent is greater than 0



                                                                if (taxPercent > 0) {
                                                                    if (generatedInvoice && generatedInvoice.taxPaidBy === "Company") {
                                                                        total = total * 100 / (100 + taxPercent);
                                                                    }
                                                                }

                                                                return total.toFixed(2);
                                                            })()
                                                        }
                                                    </td>
                                                    <td
                                                        className="ant-table-row-cell-break-word"
                                                        hidden={!this.state.hasConversionRate}
                                                    >
                                                        {
                                                            this.state.taxPercentange > 0
                                                                ? (() => {

                                                                    const commission =
                                                                        invoice.commissionTypeFrom === 'Percentage'
                                                                            ? (
                                                                                parseFloat(invoice.commissionFromCourse || 0) *
                                                                                parseFloat(invoice.tutionFee || 0) / 100
                                                                            )
                                                                            : parseFloat(invoice.commissionFromCourse || 0);

                                                                    const total =
                                                                        commission *
                                                                        parseFloat(invoice.conversionRate || 0);

                                                                    if (this.state.generatedInvoice && this.state.generatedInvoice.taxPaidBy === "Company") {

                                                                        return (
                                                                            total *
                                                                            this.state.taxPercentange /
                                                                            (this.state.taxPercentange + 100)
                                                                        ).toFixed(2);

                                                                    } else if (this.state.generatedInvoice && this.state.generatedInvoice.taxPaidBy === "University") {
                                                                        return (
                                                                            total *
                                                                            this.state.taxPercentange / 100
                                                                        ).toFixed(2);
                                                                    }
                                                                })()
                                                                : '0.00'
                                                        }
                                                    </td>
                                                    <td className='ant-table-row-cell-break-word' hidden={!this.state.hasConversionRate}><Input onChange={(e) => { this.updateValue('adjustmentAmount', index, e) }} value={invoice.adjustmentAmount} /></td>
                                                    <td
                                                        className="ant-table-row-cell-break-word"
                                                        hidden={!this.state.hasConversionRate}
                                                    >
                                                        {
                                                            (() => {

                                                                const commissionFromCourse =
                                                                    parseFloat(invoice.commissionFromCourse || 0);

                                                                const tutionFee =
                                                                    parseFloat(invoice.tutionFee || 0);

                                                                const conversionRate =
                                                                    parseFloat(invoice.conversionRate || 0);

                                                                const adjustmentAmount =
                                                                    parseFloat(invoice.adjustmentAmount || 0);

                                                                const taxPercent =
                                                                    parseFloat(this.state.taxPercentange || 0);

                                                                const generatedInvoice =
                                                                    this.state.generatedInvoice;

                                                                let total = 0;

                                                                // STEP 1: BASE COMMISSION
                                                                if (invoice.commissionTypeFrom === 'Percentage') {

                                                                    total =
                                                                        (commissionFromCourse * tutionFee / 100)
                                                                        * conversionRate;

                                                                } else if (commissionFromCourse && conversionRate) {

                                                                    total =
                                                                        commissionFromCourse * conversionRate;
                                                                }

                                                                let finalAmount = total;

                                                                // COMPANY => TAX ALREADY INCLUDED
                                                                if (
                                                                    taxPercent > 0 && generatedInvoice &&
                                                                    generatedInvoice.taxPaidBy === "Company"
                                                                ) {

                                                                    finalAmount =
                                                                        total + adjustmentAmount;

                                                                }

                                                                // UNIVERSITY => TAX EXTRA
                                                                else if (
                                                                    taxPercent > 0 && generatedInvoice &&
                                                                    generatedInvoice.taxPaidBy === "University"
                                                                ) {

                                                                    const taxAmount =
                                                                        (total * taxPercent) / 100;

                                                                    finalAmount =
                                                                        total + taxAmount + adjustmentAmount;

                                                                }

                                                                // NO TAX
                                                                else {

                                                                    finalAmount =
                                                                        total + adjustmentAmount;
                                                                }

                                                                return finalAmount.toFixed(2);

                                                            })()
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <Row>
                        <br />
                        <Col span={24}>
                            <select
                                name='taxPaidBy'
                                value={generatedInvoice.taxPaidBy}
                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                className='form-control'
                                onChange={(e) => {
                                    generatedInvoice.taxPaidBy = e.target.value
                                    this.setState({ generatedInvoice })
                                }}
                            >
                                <option value="">Choose Tax Paid By</option>
                                <option value="Company">Company</option>
                                <option value="University">University</option>
                            </select>
                        </Col>
                        {
                            generatedInvoice.taxPaidBy ?
                                <Col span={24}>
                                    <Row>
                                        <Col span={8}>
                                            <select
                                                name='taxTypeId'
                                                value={taxTypeId}
                                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                                className='form-control'
                                                onChange={(e) => this.updateCpTax(e.target.value)}
                                            >
                                                <option value="">Choose Tax</option>
                                                {
                                                    allTaxes && allTaxes.length ?
                                                        allTaxes.map((item, index) => {
                                                            return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                        })
                                                        : null
                                                }
                                            </select>
                                        </Col>
                                    </Row>
                                </Col>
                                : null
                        }
                        <br />
                        <Input type='date' defaultValue={invoiceReceivingDate} style={{ maxWidth: '300px' }} className='form-control' onChange={(e) => { this.selectInvoiceReceivingDate(e) }} />
                        <br />
                        <select name='invoiceStatus' value={generatedInvoice.invoiceStatus} style={{ maxWidth: '300px' }} className='form-control' onChange={(e) => { this.selectInvoiceStatus(e) }}>
                            <option value="">Select Option</option>
                            {
                                invoiceStatuses && invoiceStatuses.length ?
                                    invoiceStatuses.map((item, index) => {
                                        return (<option value={item} key={index}>{item}</option>)
                                    })
                                    : null
                            }
                        </select>
                        <br />
                        {
                            this.state.invoiceStatus === "Paid by Uni" || this.state.invoiceStatus === "Cleared" ?
                                <>

                                    <Row style={{ marginBottom: '20px' }}>
                                        <Col span={12}>
                                            <Checkbox
                                                checked={this.state.hasConversionRate}
                                                onChange={(y) => {
                                                    const checked = y.target.checked;

                                                    this.setState({ hasConversionRate: checked }, () => {
                                                        if (checked && this.tableScrollRef.current) {
                                                            this.tableScrollRef.current.scrollTo({
                                                                left: this.tableScrollRef.current.scrollWidth,
                                                                behavior: 'smooth'
                                                            });
                                                        }
                                                    });
                                                }}
                                            >
                                                <Popover placement="bottomLeft" content={content}>
                                                    <span
                                                        style={{
                                                            color: "#1890FF",
                                                            fontWeight: "bold",
                                                            cursor: "pointer",
                                                            marginLeft: 4
                                                        }}
                                                    >
                                                        Add Exchange Rate{" "} !
                                                    </span>
                                                </Popover>
                                            </Checkbox>

                                        </Col>
                                        {
                                            this.state.hasConversionRate ?
                                                <Col span={24} style={{ marginTop: 10 }}>
                                                    <Checkbox
                                                        checked={this.state.additionalDeduction}
                                                        onChange={(y) => {
                                                            const checked = y.target.checked;

                                                            this.setState({ additionalDeduction: checked }, () => {
                                                                if (checked && this.tableScrollRef.current) {
                                                                    this.tableScrollRef.current.scrollTo({
                                                                        left: this.tableScrollRef.current.scrollWidth,
                                                                        behavior: 'smooth'
                                                                    });
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        <Popover placement="bottomLeft" content={content}>
                                                            <span
                                                                style={{
                                                                    color: "#1890FF",
                                                                    fontWeight: "bold",
                                                                    cursor: "pointer",
                                                                    marginLeft: 4
                                                                }}
                                                            >
                                                                Any Additional Tax{" "} !
                                                            </span>
                                                        </Popover>
                                                    </Checkbox>

                                                </Col>
                                                : null
                                        }
                                        {
                                            this.state.additionalDeduction ?
                                                <Col span={24} style={{ marginTop: 10 }}>
                                                    <Row>
                                                        <Col span={8}>
                                                            <select
                                                                name='taxTypeId'
                                                                value={generatedInvoice.additionalTaxTypeId}
                                                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                                                className='form-control'
                                                                onChange={(e) => this.updateAdditionalCpTax(e.target.value)}>
                                                                <option value="">Choose Additional Tax</option>
                                                                {
                                                                    allTaxes && allTaxes.length ?
                                                                        allTaxes.map((item, index) => {
                                                                            return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                                        })
                                                                        : null
                                                                }
                                                            </select>
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                : null
                                        }
                                        {
                                            this.state.hasConversionRate ?
                                                <Col span={24} style={{ marginTop: 10 }}>
                                                    <Checkbox
                                                        checked={this.state.hasBankCharges}
                                                        onChange={(y) => {
                                                            const checked = y.target.checked;

                                                            this.setState({ hasBankCharges: checked }, () => {
                                                                if (checked && this.tableScrollRef.current) {
                                                                    this.tableScrollRef.current.scrollTo({
                                                                        left: this.tableScrollRef.current.scrollWidth,
                                                                        behavior: 'smooth'
                                                                    });
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        <Popover placement="bottomLeft" content={content}>
                                                            <span
                                                                style={{
                                                                    color: "#1890FF",
                                                                    fontWeight: "bold",
                                                                    cursor: "pointer",
                                                                    marginLeft: 4
                                                                }}
                                                            >
                                                                Any Bank Charges{" "} !
                                                            </span>
                                                        </Popover>
                                                    </Checkbox>

                                                </Col>
                                                : null
                                        }
                                        {
                                            this.state.hasBankCharges ?
                                                <Col span={24} style={{ marginTop: 10 }}>
                                                    <Row>
                                                        <Col span={8}>
                                                            <Input
                                                                type={'text'}
                                                                name="bankCharges"
                                                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                                                placeholder={`Bank Charges ${companyCurrency}`}
                                                                value={generatedInvoice.bankCharges}
                                                                onChange={(e) => {
                                                                    generatedInvoice.bankCharges = e.target.value
                                                                    this.setState({ generatedInvoice })
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>

                                                : null
                                        }
                                    </Row>


                                    <Upload
                                        style={{ marginBottom: 30 }}
                                        label={'Upload Payment Receipt'}
                                        name={'file'}
                                        action={`${LAPI_URL}/filesUploader`}
                                        onChange={this.handleChange}
                                        onRemove={this.onRemove}>
                                        <Button>
                                            <Icon type="upload" /> Payment Receipt
                                        </Button>
                                    </Upload>
                                </>

                                : null
                        }
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="button"
                                style={{ marginBottom: 10, marginTop: 10 }}
                                onClick={() => { this.updateInvoiceStatus() }}
                                loading={this.state.loading}>
                                Update
                            </Button>
                        </Col>
                        <Col span={8} />
                    </Row>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupInvoiceChangeStatus)